export var Host = "http://45.64.246.135:8096/api/"
export var FileUrl = "http://tpssth.cc/"
export var SendTime = 180
